<div fxLayout="row" fxLayoutAlign="end">
  <mat-icon
    (click)="closeDialog()"
    svgIcon="dls-times-plain-light"
    fxHide.lt-md
    class="x_procedures_button text-bold"
  >
  </mat-icon>
</div>

<div class="procedures-awareness-overlay-component" fxLayout="row">
  <span fxHide.lt-md class="margin right-2x">
    <img
      src="/assets/images/procedure-cost-icon-in-circle.svg"
      aria-hidden="true"
      alt=""
    />
  </span>

  <div>
    <div fxLayout="row">
      <span fxHide.gt-sm class="margin right-1x pad top-1x">
        <img
          src="/assets/images/procedure-cost-icon-in-circle.svg"
          aria-hidden="true"
          alt=""
        />
      </span>
      <h4 class="bold">
        {{ 'procedures_awareness_overlay_header' | translate }}
      </h4>
    </div>
    <p
      [innerHTML]="'procedures_awareness_overlay_body' | translate"
      class="strong"
      ngClass.gt-md="pad right-3x"
      ngClass.lt-lg="pad right-2x"
    ></p>
  </div>
</div>

<div fxLayout="row" fxLayoutAlign.gt-sm="end">
  <button
    (click)="closeDialog()"
    ngClass.gt-md="width-20"
    class="no-outline platform-button mat-flat-button close_procedures_button mat-accent"
  >
    {{ 'procedures_awareness_overlay_button' | translate }}
  </button>
</div>
